// form input validation
export const passwordMinLengthValidation = 'Password kamu kurang dari 8 karakter.';
export const passwordUpperLowerValidation =
  'Password harus terdiri dari huruf besar dan huruf kecil.';
export const passwordSymbolValidation = 'Password wajib ada 1 simbol !@#$%^&*() dan 1 angka.';

export const retypePasswordValidation = 'Oops, password yang kamu masukkan tidak sama.';
export const phoneNumberMinLengthValidation = 'Nomor Hp kamu kurang dari 5 karakter.';
export const phoneNumberMaxLengthValidation = 'Nomor Hp kamu lebih dari 20 karakter.';
export const emailValidation = 'Alamat email tidak valid. Coba periksa lagi, ya.';
export const fullNameMaxLengthValidation = 'Mohon persingkat nama lengkapmu.';
export const firstNameMaxLengthValidation = 'Mohon persingkat nama depanmu.';
export const lastNameMaxLengthValidation = 'Mohon persingkat nama belakangmu.';
